import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import favorites_gen_2 from '@devices/settings/device_settings/favorites_gen_2.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import roller_app_setting_gen_2 from '@devices/settings/device_settings/roller_app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import roller_settings_gen_2 from '@devices/settings/device_settings/roller_settings_gen_2.js';
import bluetooth_bt_home_control_gen_2 from '../device_settings/bluetooth_bt_home_control_gen_2';

export default [
	schedule_gen_2,
	webhooks_gen_2,
	scripts_gen_2,
	favorites_gen_2,
	virtual_components_pro_devices,
	networks_gen_2_pro,
	bluetooth_bt_home_control_gen_2,
	roller_app_setting_gen_2,
	share,
	roller_settings_gen_2,
];
